module.exports = __webpack_public_path__ + "static/media/Love Is Where You Are.bdbca194.jpg";